import { useEffect } from "react";
import logo from "../assets/logo_saha.png";
import image1 from "../assets/domain/1.png";
import image2 from "../assets/domain/2.png";
import image3 from "../assets/domain/3.png";
import image4 from "../assets/domain/4.png";
import image5 from "../assets/domain/5.png";
import image6 from "../assets/domain/6.jpg";
import image7 from "../assets/domain/7.jpg";
import image8 from "../assets/domain/8.jpg";
import image9 from "../assets/domain/9.jpg";
import image10 from "../assets/domain/10.jpg";
import "./KurulumKilavuzu.css";

const steps = [
    {
        image: image1,
        description: (
            <>
                Sportive Saha uygulamasının kurulumu ve kişiye özel bilgilerinizi alabilmek için{" "}
                <a
                    href="https://info.sportivespor.com.tr/mobil-kurulum"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    linke tıklayınız.
                </a>
            </>
        )
    },
    {
        image: image2,
        description: "@sportive.com.tr uzantılı e-posta adresinizi giriniz, kullandığınız telefonun platformunu seçiniz ve “Doğrulama kodu gönder” butonuna basınız."
    },
    {
        image: image3,
        description: "Girdiğiniz e-posta adresi doğruysa sistem adresinize bir doğrulama kodu gönderecektir. Kodu bu ekrana yazıp “Doğrula ve bilgileri gönder” butonuna basın."
    },
    {
        image: image4,
        description: "E-posta adresiniz doğruysa aşağıdaki gibi bir ileti alacaksınız. Buradaki doğrulama kodunu 3. adımdaki doğrulama ekranına girin."
    },
    {
        image: image5,
        description: "Doğrulama kodunu doğru girerek işlemi tamamladığınızda kurulum için gereken bilgiler e-posta adresinize iletilecektir. Bu bilgiler size özeldir ve kimseyle paylaşılmamalıdır. Uygulama linki kısmındaki bağlantıya tıklayarak uygulamayı telefonunuza kurunuz."
    },
    {
        image: image6,
        description: "Bu ekrana girmeniz gereken bilgiler 5. adımda gönderilen e-postada yer almaktadır. Bilgilerin eksiksiz ve doğru şekilde girilmesi gerekmektedir."
    },
    {
        image: image7,
        description: "Bilgilerin girilmiş hâlinin örnek görüntüsü aşağıdaki gibidir. Bilgileri girdikten sonra “Kaydet” butonuna basınız."
    },
    {
        image: image8,
        description: "Girdiğiniz bilgiler doğruysa aşağıdaki bilgilendirme ekranı açılacaktır. “Tamam” butonuna basınız."
    },
    {
        image: image9,
        description: "Kullanıcı adı ve şifre alanlarına bilgisayar kullanıcı adınızı ve bilgisayar açılış şifrenizi girmeniz gerekmektedir."
    },
    {
        image: image10,
        description: "Örnek giriş bilgisi aşağıdaki resimde paylaşılmıştır. Giriş ekranında kullanıcı adınızı ve şifrenizi girdikten sonra “Bilgileri Hatırla” seçeneğini işaretleyip “Giriş Yap” butonuna basınız. Bu seçeneği işaretlerseniz sonraki girişlerinizde bilgilerinizi tekrar yazmanız gerekmez."
    }
];

export default function KurulumKilavuzuDomain() {
    useEffect(() => {
        const previousLanguage = document.documentElement.lang;
        document.documentElement.lang = "tr";

        const meta = document.createElement("meta");
        meta.name = "google";
        meta.content = "notranslate";
        document.head.appendChild(meta);

        return () => {
            document.documentElement.lang = previousLanguage;
            meta.remove();
        };
    }, []);

    return (
        <main className="kilavuz-page notranslate" translate="no" lang="tr">
            <header className="kilavuz-header">
                <img src={logo} alt="Sportive Saha" />
                <h1>Kurulum Kılavuzu</h1>
            </header>

            <section className="kilavuz-steps" aria-label="Domain kurulum adımları">
                {steps.map((step, index) => (
                    <article className="kilavuz-step" key={step.image}>
                        <h2>{index + 1}. Adım</h2>
                        <p>{step.description}</p>
                        <img
                            src={step.image}
                            alt={`Domain kurulum kılavuzu ${index + 1}. adım ekran görüntüsü`}
                            loading={index > 1 ? "lazy" : "eager"}
                        />
                    </article>
                ))}
            </section>

            <footer className="kilavuz-welcome">Sportive SAHA’ya Hoş Geldiniz.</footer>
        </main>
    );
}
